import { authorizedManageAccounts } from '@/backend/features/background-check';
import { requireAnySystemPermission, SystemPermissionType } from '@juvare/contact-management/backend/features/permissions/shared';
import { ReadonlyStorageContext } from '@juvare/platform-app/App';
import { UserState } from '@juvare/platform-sdk-react/types';

interface AuthorizedManageAccountsParams {
    userState: UserState;
    accountIds: string[];
}

export function requireManageAccountsAndAnySystemPermission(
    context: ReadonlyStorageContext,
    { userState, accountIds }: AuthorizedManageAccountsParams,
    ...systemPermissions: SystemPermissionType[]
): boolean {
    if (!requireAnySystemPermission(userState, ...systemPermissions)) {
        return false;
    }
    return authorizedManageAccounts(context, { userState, accountIds });
}
